import React, { Component } from "react";
import ReportV1 from "./ReportV1";
import ReportV2 from "./ReportV2";
import { Loader } from "../../components";
import { getLanguage } from "../../utils/utils";
import API from "../../api";

// Questionnaire type that gets the V2 report layout.
const V2_TYPE_ID = 2;

// Which layout to use depends on the questionnaire type, and the type only
// arrives with the report payload.
//
// This resolves the type first and then mounts the matching variant, so each
// variant is a real component with its own instance methods. Borrowing
// renderReport() from the other class does not work: the variants define their
// helpers as class fields, which live on the instance rather than the
// prototype, so a ReportV1 instance has none of ReportV2's helpers.
//
// The extra request is cheap - the report is fetched without benchmark
// parameters here, and the variant's own load populates the full payload.
export default class ReportRouter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      typeId: undefined,
    };
  }

  componentDidMount() {
    this.loadType();
  }

  loadType = async () => {
    await API.get("", {
      params: {
        id: this.props.match.params.id,
        action: "report",
        language: getLanguage(),
      },
    })
      .then((response) => {
        this.setState({
          typeId:
            response.data && response.data.info
              ? response.data.info.typeId
              : null,
        });
      })
      .catch(() => {
        // Fall back to the original layout rather than showing nothing.
        this.setState({ typeId: null });
      });
  };

  render() {
    const { typeId } = this.state;

    if (typeId === undefined) {
      return <Loader />;
    }

    return typeId === V2_TYPE_ID ? (
      <ReportV2 {...this.props} />
    ) : (
      <ReportV1 {...this.props} />
    );
  }
}
